/**
 * Represents an error originating inside of Denzel server-side.
 * The structure should stay in sync with the Denzel Error class.
 *
 * @constructor
 * @extends {Error}
 */
const DenzelError = function() {
  /** @override */
  this.name = 'DenzelError';

  /**
   * the string form of a Denzel error code
   * @type {?string}
   */
  this.code = null;

  /**
   * the http status code
   * @type {?number}
   */
  this.http_status = null;

  /**
   * if the error is an API error, the numeric API error code
   * @type {?number}
   */
  this.api_error_code = null;

  /** @type {?} */
  this.target = null;

  /** @type {?string} */
  this.stack_trace = null;

  /** @type {Object} */
  this.extra_data = null;

  /** @type {?string} */
  this.request_identifier = null;

  this.message = null;

  this.message_detail = null;

  this.original_message = null;
};

DenzelError.prototype = new Error();
DenzelError.prototype.constructor = DenzelError;
DenzelError.prototype.toString = function() {
  return (
    '[' +
    this.name +
    '] ' +
    JSON.stringify({
      name: this.name,
      code: this.code,
      http_status: this.http_status,
      api_error_code: this.api_error_code,
      target: this.target,
      stack_trace: this.stack_trace,
      extra_data: this.extra_data,
      request_identifier: this.request_identifier,
    })
  );
};

/**
 * Create an Error object from a plain object.
 *
 * @param {!Object} obj
 * @return {!DenzelError}
 */
DenzelError.fromPlainObject = function(obj, data) {
  const error = new DenzelError();
  if (obj.message) {
    error.message = obj.message;
  }
  if (obj.message_detail) {
    error.message_detail = obj.message_detail;
  }
  if (obj.original_message) {
    error.original_message = obj.original_message;
  }
  if (obj.code) {
    error.code = obj.code;
  }
  if (obj.http_status) {
    error.http_status = obj.http_status;
  }
  if (obj.api_error_code) {
    error.api_error_code = obj.api_error_code;
  }
  if (obj.stack_trace) {
    error.stack_trace = obj.stack_trace;
  }
  if (obj.extra_data) {
    error.extra_data = obj.extra_data;
  }
  if (obj.request_identifier) {
    error.request_identifier = obj.request_identifier;
  }
  if (data) {
    error.data = data;
  }
  return error;
};

export default DenzelError;
